import { decodeSseData } from '@avisoma/agent-core/events';
function frameData(block) {
    return block
        .split('\n')
        .filter((line) => line.startsWith('data: '))
        .map((line) => line.slice(6))
        .join('\n');
}
/**
 * Parses an SSE byte stream into `AgentEvent`s. A `data:` line that fails to
 * parse as JSON (`SyntaxError`) is skipped rather than aborting the stream —
 * `decodeSseData` throws `SyntaxError` on malformed JSON.
 */
export async function* parseSseStream(body) {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    const buffer = { text: '' };
    try {
        for (;;) {
            const { value, done } = await reader.read();
            if (done)
                return;
            buffer.text += decoder.decode(value, { stream: true });
            for (;;) {
                const sep = buffer.text.indexOf('\n\n');
                if (sep < 0)
                    break;
                const data = frameData(buffer.text.slice(0, sep));
                buffer.text = buffer.text.slice(sep + 2);
                if (!data)
                    continue;
                try {
                    yield decodeSseData(data);
                }
                catch (err) {
                    // Malformed JSON (SyntaxError) or an event type this build does not
                    // know (plain Error) are both skipped: the protocol contract says a
                    // consumer ignores unknown event types.
                    if (err instanceof Error)
                        continue;
                    throw err;
                }
            }
        }
    }
    finally {
        // An early consumer exit (cancel, unmount) must cancel the underlying stream
        // and release the reader, or the body stays locked.
        await reader.cancel().catch(() => undefined);
        reader.releaseLock();
    }
}
//# sourceMappingURL=sse.js.map